import SecurityRule from './security.rule';

class CaptchaRule extends SecurityRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.public_key = window.imaios.get(sha256('publicKeyCaptcha'));
        this.token = null;
        this.token_timestamp = null;

        this.generateInputTag();
    }

    generateInputTag() {
        const form = this.getForm();
        let input = form.querySelector('input[name="'+form.getAttribute('name')+'[_captchatoken]"]');
        if (input === null) {
            input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', form.getAttribute('name')+'[captchatoken]');
            input.setAttribute('action', this.getFormID());
            form.append(input);

        }

        this.inputElement = input;
    }

    getNewToken(settings = {action: 'form'}) {
        return new Promise(resolve => {
            if (this.isRecaptchaLoaded()) {
                window.grecaptcha.execute(this.public_key, settings).then(token => {
                    this.setCaptchaToken(token);
                    resolve(token);
                });
            }

            else {
                this.setCaptchaToken('');
                resolve('');
            }
        });
    }

    isRecaptchaLoaded() {
        return typeof window.grecaptcha !== 'undefined';
    }

    hasToken() {
        const now = Date.now();

        return (
            this.token !== null &&
            this.token_timestamp - now > 30000
        );
    }

    setCaptchaToken(token) {
        this.token = token;
        this.token_timestamp = Date.now();
        this.inputElement.value = token;
    }

    async apply(settings) {
        await this.getNewToken(settings);


        // return this.token;
        return true;
    }
}

export default CaptchaRule;
